import { defineStore } from 'pinia'
import { watch, onUnmounted, unref, type Ref, type MaybeRef } from 'vue'

export const useFormDirtyStore = defineStore('formDirty', {
  state: () => ({
    dirtyKeys: new Set<string>(),
  }),
  getters: {
    isDirty: (state) => state.dirtyKeys.size > 0,
  },
  actions: {
    setDirty(key: string, value: boolean) {
      if (value) this.dirtyKeys.add(key)
      else this.dirtyKeys.delete(key)
    },
    clear(key: string) {
      this.dirtyKeys.delete(key)
    },
  },
})

export function useFormDirty(key: MaybeRef<string>, isDirtyRef: Ref<boolean>) {
  const store = useFormDirtyStore()

  watch(
    () => unref(key),
    (newKey, oldKey) => {
      if (oldKey && oldKey !== newKey) store.clear(oldKey)
      store.setDirty(newKey, isDirtyRef.value)
    },
    { immediate: true },
  )

  watch(isDirtyRef, (value) => store.setDirty(unref(key), value))

  onUnmounted(() => store.clear(unref(key)))
}
